<template>
    <div>
        <el-row type="flex" justify="center" class="hidden-md-and-up">
            <el-col :xs="22">
                <el-row>
                    <el-col :xs="24">
                        <el-row type="flex" justify="center" class="h-menu-panel" >
                            <el-col :md="20" class="h-menu-title">
                                <div class="news-sub">PRODUCT</div>
                                <div class="news-title" >产品介绍</div>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :xs="24">
                        <el-col :xs="8" v-for="(item,index) in list" :key="index" @click="selectType(index)" class="lists">
                            <div class="item">
                                 <span style="font-size: 30px;" :style="{color:item.baner.before}" :class="item.baner.icon" class="iconfont"></span>
                                 <span >{{item.baner.title}}</span>    
                            </div>
                        </el-col>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <el-row style="height: 350px;margin-top: 20px;" type="flex" justify="center" class="hidden-md-and-up">
            <el-col :xs="22" style="height: 100%;overflow: hidden;">
                <el-carousel height="350px" :autoplay="true">
                    <el-carousel-item  v-for="(item,index) in list[idx].products" :key="index">
                      <div class="phone-swiper">
                          <div class="top-img">
                                    <img :src="item.proImg" style="height: 200px;"/>
                          </div>
                          <div class="btm-info">
                                    <div>{{item.id}}</div>
                                    <div>{{item.title}}</div>
                           </div>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
            </el-col>
        </el-row>
        <section class="buyWay">
            <el-row type="flex" justify="center" style="padding: 80px 0;height: 100%;">
                <el-col :md="22" class="shop" >
                    <el-col :md="7" >
                        <el-row type="flex" justify="center">
                            <el-col :xs="22" class="shop_left">
                                        <div >
                                            <p class="iconfont mh-hulianwang" style="font-size: 40px;"></p>
                                        </div>
                                        <div class="mylink">
                                            <a href="http://www.biogaia.cn/" title="点击打开拜奥中国官网" target="_blank"><span class="hvr-bounce-in">{{$t('service.baiao.link.china')}}</span></a>
                                            <a href="https://www.biogaia.com/" title="点击打开海外官网" target="_blank"><span class="hvr-bounce-in">{{$t('service.baiao.link.word')}}</span> </a>
                                        </div>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :md="17" class="shop_right">
                        <el-col :md="24" style="margin-bottom: 30px;" class="hidden-sm-and-down">
                            <div style="display: flex;">
                                <div class="buy_way">
                                    <span>{{$t('service.baiao.buymethod.channel')}}</span>
                                    <span>PURCHASE CHANNEL</span>
                                </div>
                                <!-- <p class="buy_way" data-msg="PURCHASE CHANNEL"></p> -->
                                <div class="buy_msg">{{$t('service.baiao.buymethod.infomation')}}</div>
                            </div>
                        </el-col>
                        <el-col :md="24"  class="hidden-md-and-up" style="padding: 50px 0 20px;">
                            <el-row type="flex" justify="center"  >
                                <el-col :md="22" style="display: flex;flex-direction: column;text-align: center;">
                                    <span class="news-sub" >{{$t('service.baiao.buymethod.channel')}}</span>
                                    <span style="font-size: 14px;" >{{$t('service.baiao.buymethod.infomation')}}</span>
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col :md="24" >
                            <el-col :md="12" :xs="12" :sm="12" v-for="(item,index) in appShops" :key="index">
                                <div class="shop-address " >
                                     <div class="shop-net hidden-sm-and-down">
                                         <div class="shop-link hvr-bounce-in">
                                             <a :href="item.href" target="_blank"><p class="iconfont mh-hulianwang"
                                              style="font-size: 30px;height: 100px;line-height: 100px;margin: 0;"></p></a> 
                                             <!-- <p style="margin-top: 10px;"> 网页端</p> -->
                                         </div>
                                         <div class="shop-code hvr-bounce-in">
                                             <img :src="item.code" width="100px" height="100px" class="shop_logo"/>
                                             <!-- <p style="margin-top: 10px;">手机端</p> -->
                                         </div>
                                     </div>
                                    <img :src="item.icon" width="100%" class="shop_logo hidden-sm-and-down"/>
                                    <a :href="item.href" target="_blank"><img  :src="item.icon" width="100%" class="shop_logo hidden-md-and-up"/></a> 
                                </div>
                            </el-col>
                        </el-col>
                    </el-col>
                </el-col>
            </el-row>
        </section>
        
        <section class="search-main">
            <el-row type="flex" justify="center">
                <el-col :md="24" class="h-menu-title">
                    <div class="news-sub">STUDY</div>
                    <div class="news-title" >{{$t('service.baiao.serch.title')}}</div>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center" style="width: 100%;padding: 0 0 20px 0;">
                <el-col :md="18" class="">
                    <el-col :xs="8" :sm="8" :md="4" v-for="(item,index) in searchData" :key="index" class="">
                        <div class="c-data ">
                            <div class="d-dta-item">
                                <div class="data" :data-info="item.unit" >{{item.data}}</div>
                                <span style="text-align: center;font-size: 14px;font-weight: bold;">{{item.msg}}</span>
                            </div> 
                        </div>
                    </el-col>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center" class="search-detail">
                <el-col :md="22" :xs="23" >
                    <el-col :md="4" class="hidden-sm-and-down">
                        <p style="color: #443530;font-weight: bold;font-size: 24px;margin: 0;">{{$t('service.baiao.serch.subtitle')}}</p>
                        <p style="color: #443530;font-size: 14px;margin: 0;">Clinical research</p>
                    </el-col>
                    <el-col :md="24" class="hidden-md-and-up" style="text-align: center;">
                        <p style="color: #443530;font-weight: bold;font-size: 24px;margin: 0;">{{$t('service.baiao.serch.subtitle')}}</p>
                        <p style="color: #443530;font-size: 14px;margin: 0;">Clinical research</p>
                    </el-col>
                    <el-col :md="20" :xs="24">
                        <el-row :gutter="20" class="search-content">
                            <el-col :md="12" v-for="(item,index) in newsList" v-show="index < 4" :key="index" class="">
                                    <div  class="content-main mh-hvr">
                                        <div class="date">
                                            <p class="iconfont mh-rili" style="font-size: 18px;"></p><p>{{item.inputTime}}</p>
                                        </div>
                                        <div class="content">
                                            <div class="title">
                                                <a :href="'/newsinfo/?id='+item.id" target="_blank">{{item.title}}</a> 
                                            </div>
                                            <div class="msg">{{item.subContent}}</div>
                                        </div>
                                    </div>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-col>
            </el-row>
        </section>
        <section class="search-btm">
            <el-row  type="flex" justify="center" >
                <el-col :md="22"   class="btm-panle">
                    <el-col :md="4" :xs="24" style="padding:0 0 10px 0;">
                        <p style="color: #443530;font-weight: bold;font-size: 24px;margin: 0;">{{ $t('service.baiao.searchtitle') }}</p>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 
                        <p style="color: #443530;font-size: 14px;margin: 0;">2022 - 2023</p>
                    </el-col>
                    <el-col :md="24" :xs="24">
                        <el-row :gutter="20">
                            <el-col :sm="12" :xs="12" :md="6" class="btm-itms " v-for="(item,index) in searchFinds" :key="index">
                                    <div class="el-col ">
                                        <div class="title">{{item.title}}</div>
                                        <div class="itm-list">
                                            <div class="data" :data-unit="itm.unit" :data-before="itm.msg" v-for="(itm,idx) in item.datas" :key="idx">{{itm.data}}</div>
                                        </div>
                                    </div>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-col>
            </el-row>
        </section>
    </div>
</template>

<script>
    import Swiper from 'swiper';
    // import moduleSwiper from '../moduleSwiper/moduleSwiper.vue';
    export default{
        name:'myBaiao',
        data() {
            return{
                show:false,
                appShops:[
                    {
                        id:1,icon:require('@/assets/images/service/shop/s1.jpg'),
                        href:'https://m.tb.cn/h.53pj9Dp',
                        code:require('@/assets/images/service/shop/s1code.png')
                    },
                    {
                        id:2,icon:require('@/assets/images/service/shop/s2.jpg'),
                        href:'https://mall.jd.com/index-1000136481.html?from=pc',
                        code:require('@/assets/images/service/shop/s2code.png')
                    },
                    {
                        id:3,
                        icon:require('@/assets/images/service/shop/s3.jpg'),
                        href:'https://v.douyin.com/ieY3NFpa',
                        code:require('@/assets/images/service/shop/s3code.png')
                    },
                    {
                        id:4,icon:require('@/assets/images/service/shop/s4.jpg'),
                        href:'https://mobile.yangkeduo.com/mall_page.html?mall_id=563873175&ts=1693750120617&has_decoration=0&msn=bpz6xlj7qqlkxizm6ikig2ehny_axbuy&refer_share_id=bc6dc2e98ed84fb5a112bde18ab5d1b3&refer_share_uin=3KPNICEVDXTIKQLJOE26NE2FZ4_GEXDA&refer_share_channel=copy_link&refer_share_form=text',
                        code:require('@/assets/images/service/shop/s4code.png')
                    }
                ],
                list:this.$t('service.baiao.list'),
                products:[
                    {
                     bgImg:'https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/service/ser-pro-01.png',
                     products:[
                         {id:1,img:'https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/service/ser-pro-bg.png'}
                        ]  
                    }
                ],
                searchData:this.$t('service.baiao.serch.searchData'),
                searchFinds:this.$t('service.baiao.searchFinds'),
                oneNews:this.$t('service.baiao.snews'),
                idx:0,
                windowWidth:window.innerWidth,
                newsList:[]
            }
        },
        computed:{
          currentIdx(){
              return this.mySwiperMainIndex
          }
          },
        mounted() {
             this.slideBanner()
        },
        created() {
            this.$axios.get('http://www.drmums.com/article/research').then(
              res=>{
                  this.newsList = res.data.data
              }
            )
            this.show = true
        },
        methods:{
            
            selectType(index){
                this.idx = index
            },
            redirect(tag,idx){
                  switch(tag){
                     case "web":
                            switch(idx){
                                case 0:
                                     window.open('http://www.biogaia.cn/','_blank')
                                     break;
                                case 1:
                                    window.open('https://www.biogaia.com/','_blank')
                                         break;
                            }
                        break;
                     case "shop":
                     
                        break;
                  }
              
            },
            slideBanner() {
              //选中的轮播图
              var box = document.querySelector('.el-carousel__container');
              var startPointX = 0
              var stopPointX = 0
              //重置坐标
              var resetPoint = function () {
                startPointX = 0
                stopPointX = 0
              }
              //手指按下
              box.addEventListener("touchstart", function (e) {
                //手指点击位置的X坐标
                startPointX = e.changedTouches[0].pageX
              });
              //手指滑动
              box.addEventListener("touchmove", function (e) {
                //手指滑动后终点位置X的坐标
                stopPointX = e.changedTouches[0].pageX
              });
              //当手指抬起的时候，判断图片滚动离左右的距离
              let that = this
              box.addEventListener("touchend", function (e) {
                if (stopPointX == 0 || startPointX - stopPointX == 0) {
                  resetPoint()
                  return
                }
                if (startPointX - stopPointX > 0) {
                  resetPoint()
                  that.$refs.slideCarousel.next()
                  return
                }
                if (startPointX - stopPointX < 0) {
                  resetPoint()
                  that.$refs.slideCarousel.prev()
                  return
                }
              });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/mh.scss';
    .el-carousel__item{
         border: 1px solid rgba(0, 0, 0, .1);
         border-radius: 10px;
    }
    /deep/ .el-carousel__indicator--horizontal .el-carousel__button {
        width: 10px;
        height: 10px;
        background: transparent;
        border: 1px solid #959595;
        border-radius: 50%;
        opacity: 0.5;
      }  
      /deep/ .el-carousel__indicator--horizontal.is-active .el-carousel__button{
        width: 10px;
        height: 10px;
        background: #959595;
        border-radius: 50%;
        opacity: 1;
      }
    .phone-swiper{
        .top-img{
            width: 100%;
            position: relative;
            display: flex;
            justify-content: center;
            z-index: 2;
            height: 250px;
            align-items: center;
            &:before{
                z-index: 1;
                opacity: .1;
                content: '';
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                background-position: center;
                background-size: cover;
                background-image: url('https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/service/ser-pro-bg.png');
            }
        }
        .btm-info{
           margin-top: 10px;
           font-size: 22px;
           display: flex;
           flex-direction: row;
           height: 50px;
           align-items: center;
           div{
               &:first-child{
                   padding: 0 20px;
                   border-right: 2px solid #dedede;
               }
               &:last-child{
                   padding: 0 20px;
               }
           }
            
        }
    }
    .lists{
        padding: 2px;
        .item{
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid rgba(0, 0, 0, .05);
            border-radius: 5px;
            padding: 2px 0;
            span:last-child{
                font-size: 18px;
                font-weight: 550;
                margin-left: 5px;
            }
        }
        .active{
            background-color: #BA4D48;
            color: #FFF;
        }
        
    }
    .buyWay{
        @media only screen and (min-width:920px){
            height: 100vh;
        }
        
    }
    .search-btm{
        @media only screen and (min-width:920px){
            height: 100vh;
        }
        display: flex;flex-direction: column;justify-content: center;
        background-image: url('../../assets/images/service/search-btm.png');
        background-size: cover;
        background-position: bottom;
        .btm-panle{
            @media only screen and (max-width:920px){
                padding: 20px 20px 20px;
            }
            background-color: rgba(255, 255, 255, .9);
            padding: 40px 50px 80px;
            .btm-itms{
                .el-col{
                    @media only screen and (min-width:600px){
                       height: 550px;
                    }
                    @media only screen and (max-width:920px){
                       margin-top: 20px;
                    }
                    border-radius: 15px;
                    overflow: hidden;
                    box-shadow: 0px 1px 2px 0px #acacac;
                    .title{
                        padding: 15px;
                        text-align: center;
                        font-weight: bold;
                        font-size: 24px;
                        letter-spacing: 2px;
                        background-color: #f8c700;
                    }
                    .itm-list{
                        @media only screen and (max-width:920px){
                            padding:20px 10px 40px;
                        }
                        padding:20px  50px ;
                        .data{
                            font-size: 30px;
                            font-weight: bold;
                            position: relative;
                            color: #BA4D48;
                            &+.data{
                                        margin-top:35px;
                            }
                            &::after{
                                content: attr(data-unit);
                                font-size: 12px;
                                color: #443530;
                            }
                            &::before{
                                content: attr(data-before);
                                position: absolute;
                                font-size: 12px;
                                top: 40px;
                                left: 0;
                                color: #443530;
                            }
                        }
                    }
                }
            }
        }
        
       
    }
    .search-main{
        @media only screen and (min-width:920px){
            height: 100vh;
        }
        display: flex;align-items: center;flex-direction: column;justify-content: center;
        background-image: url('../../assets/images/service/search.jpg');
        background-size: cover;
        background-position: left bottom;
        .c-data{
            display: flex;
            flex-direction: row;
            justify-content: center;
            .d-dta-item{
                display: flex;
                flex-direction: column;
                .data{
                    display: flex;
                    justify-content: center;
                    align-items: baseline;
                    font-size: 40px;
                    color: #BA4D48;
                    font-weight: bold;
                    animation: count-up 2s ease-in-out;
                    &:after{
                        position: relative;
                        content: attr(data-info);
                        margin-left: 5px;
                        font-size: 16px;
                        color: #4f4f4f;
                    }
                }
                
                &+.d-dta-item{
                    position: relative;
                    &:after{
                        position: absolute;
                        content: '';
                        top: 5px;
                        border: 0.5px solid #ebe6e6;
                        bottom: 5px;
                    }
                }
            }
        }
        .search-detail{
            margin-top: 40px;
            .el-col{
                
                margin-bottom: 20px;
                & >div{
                }
            }
            
            .search-content{
                .content-main{
                    background-color: #FFF;
                    border: 1px solid #eaeaea;
                    padding: 20px;
                    .date{
                        padding: 5px 0;
                        margin-bottom: 10px;
                        p{
                            margin: 0;
                        }
                        .iconfont{
                            color: #BA4D48;
                            margin-right: 5px;
                        }
                        font-size: 18px;
                        display: flex;
                        border-bottom: 1px solid #dcdcdc;
                    }
                    .content{
                        .title{
                            color: #000000;
                            font-size: $h-news-title;
                            font-weight: bold;
                            padding: 4px 0;
                            overflow: hidden;
                            /* height: 49px; */
                            display: -webkit-box;
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: vertical;
                            a{
                                text-decoration: none;
                                color: #000;
                                &:hover{
                                    color: #BA4D48;
                                }
                                
                            }
                        }
                        .msg{
                            opacity: .7;
                            height: 50px;
                            padding: 5px 0;
                            font-size: $h-font-16;
                            overflow: hidden;
                            /* height: 49px; */
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                        }
                        
                    }
                }
            }
        }
    }
    
    .shop{
        position: relative;
        overflow: hidden;
        &::after{
           content: '';
               position: absolute;
               width: 100%;
               right: -20px;
               top: -50px;
               left: 0px;
               background-image: url(http://localhost:8080/img/abc.cf025ce1.png);
               background-position: right top;
               background-size: 20%;
               background-repeat: no-repeat;
               z-index: -1;
               opacity: .3;
               /* top: 0; */
               bottom: 0;
        }
        .shop_right{
            @media only screen and (min-width:920px){
                padding: 0 100px;
                height: 100%;
            }
            color: #443530;
            font-size: 16px;
            display: flex;
            
            flex-direction: column;
            justify-content: center;
            margin-bottom:40px;
            .shop_logo{
               
            }
            .shop-address{
                &:hover{
                    .shop-net{
                        opacity: 1;
                    }
                }
                
                position: relative;
                margin: 5px 5px;
                .shop-net{
                    a{
                        text-decoration: none;
                        color: #fff;
                    }
                    transition: all 0.5s ease-in;
                    opacity: 0;
                    position: absolute;
                    display: flex;
                    justify-content: space-evenly;
                    text-align: center;
                    top: 0;left: 0;right: 0;bottom: 0;
                    align-items: center;
                    background-color: rgba(0, 0, 0, .5);
                    color: #FFFFFF;
                    border: 1px solid #eaeaea;
                }
                img{
                    border: 1px solid rgba(0, 0, 0, .05);
                }
                
            }
            .buy_way{
                display: flex;
                flex-direction: column;
                padding: 0 10px;
                span{
                    &:first-child{
                        font-size: 33px;
                    }
                    &:last-child{
                        font-size: 12px;
                    }
                }
                border-right: 2px solid #6a5529;
                // position: relative;
                
                // &::before{
                //     position: absolute;
                //     content: attr(data-msg);
                //     font-size: 12px;
                //     bottom: -12px;
                // }
                // &::after{
                //     position: absolute;
                //     content: '';
                //     width: 2px;
                //     margin-left: 10px;
                //     top: 12px;
                //     bottom: 0;
                //     border-left: 1px solid;
                // }
            }
            .buy_msg{
                display: flex;
                    align-items: end;
                    /* padding: 5px; */
                    letter-spacing: 1px;
                    font-size: 22px;
                    padding: 2px 20px;
                    
                }
                
        }
        .shop_left{
            @media only screen and (max-width:920px){
                height:300px;
                max-height: 300px;
            }
            .mylink{
                display:flex;
                flex-direction: column;
                justify-content: center;
                text-align: center;
            }
            height:100vh;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            z-index: 3;
            color: #FFF;
            a{
                text-decoration: none;
                color: #FFF;
                font-weight: bold;
                font-size: 16px;
                padding: 0 10px;
            }
            &::before{
                position: absolute;
                content: '';
                background-image: url('../../assets/images/service/shop_left.jpg');
                background-size: cover;
                background-position: right center;
                background-repeat: no-repeat;
                right: 0;
                left: 0;
                bottom: 0;
                top: 0;
                z-index: -2;
            }
            &::after{
                content: '';
                background-color: #000;
                top: 0;
                position: absolute;
                right: 0;
                left: 0;
                bottom: 0;
                opacity: .3;
                z-index: -1;
            }
        }
        
    }
    .unit{
        position: relative;
        color: #443530;
        
        font-size: 40px;
        &::after{
            font-size: 14px;
            font-weight: bold;
            content: attr(data-unit);
            margin-left: 5px;
        }
    }
    .prev_next{
        color: #715c2c;
        padding: 20px 30px;
        position: absolute;z-index: 99;bottom: 0;right: 0;
        background-color: #FFCF02;
        p{
            margin: 0;
        }
        .prosIdx{
            font-size: 25px;
            text-align: center;
            border-right: 1px solid;
        }
        .prosInfo{
            padding:  0 20px;
        }
        .proCheck{
            .prev_btn{
                transform: rotate(180deg); 
            }
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            .iconfont{
                font-size: 32px;
            }
        }
    }
    h4,h5{
        line-height: normal;
    }
    .select-swiper{
        display: flex;
        align-items: center;margin-top: 20px;
        .item-icon{
            background: var(--b);
            border-radius: 50%;
            width: 60px;
            height: 60px;
            text-align: center;
            align-items: center;
            line-height: 60px;
            display: flex;
            justify-content: center;
            transition: all .5s ease-in-out;
        }
        .item-title{
            display: flex;
            align-items: center;
            font-size: 12px;
            width: 120px;
            height: 40px;
            background: var(--b);
            padding: 0 20px;
            border-top-right-radius: 20px;
            border-bottom-right-radius: 20px;
            position: relative;
            left: -11px;
            z-index: -1;
        }
    }
    
    .ac{
        background-image: url('../../assets/images/service/21.jpg');
        background-size: cover;
    }
    .news-model-title{
        position: relative;
        text-align: center;
        .news-sub{
            color: #acacac;
            opacity: .2;
        }
        h1{
            font-weight: bold;
        }
        .news-title{
            position: relative;
            top: -40px;
            font-weight: bold;
        }
    }
    .team{
        position: relative;
        .team-back{
            position: relative;
            .top-img{
                width: 100%;
                position: absolute;
                bottom: -100px;
                z-index: 2;
            }
        }
        .team-log{
            position: absolute;
            bottom: 0px;
            z-index: 2;
        }
    }
    .my-swiper{
        height: var(--h);
        width: var(--w);
        background-size: cover;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FFFFFF;
        .parallax-bg{
            position: absolute;
            left: 0;
            top: 0;
            width: 130%;
            height: 100%;
            -webkit-background-size: cover;
            background-size: 100% 100%;
            background-position: center;
        }
    }
</style>